/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rosy_Crisp_Goose_HuntInputs */

const en_rosy_crisp_goose_hunt = /** @type {(inputs: Rosy_Crisp_Goose_HuntInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete User`)
};

const de_rosy_crisp_goose_hunt = /** @type {(inputs: Rosy_Crisp_Goose_HuntInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer löschen`)
};

/**
* | output |
* | --- |
* | "Delete User" |
*
* @param {Rosy_Crisp_Goose_HuntInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rosy_crisp_goose_hunt = /** @type {((inputs?: Rosy_Crisp_Goose_HuntInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rosy_Crisp_Goose_HuntInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rosy_crisp_goose_hunt(inputs)
	return de_rosy_crisp_goose_hunt(inputs)
});